import { type AvatarLayout, Avatar } from '@playbooks/molecules/avatars';
import { Skeleton } from '@playbooks/molecules/skeletons';

export const OwnerAvatar = ({ layout = 'card' as AvatarLayout, owner, loading = false, href = null }) => {
	const props = {
		icon: 'address-card',
		thumbnail: owner.thumbnail,
		title: owner.name,
		text: owner.tagline,
		href,
		badge: owner.isVerified ? 'Verified' : 'Pending',
	};

	// Render
	if (loading) return <Skeleton className='w-20' />;
	return <Avatar layout={layout} {...props} />;
};
